import classNames from 'classnames';
import { memo } from 'react';
import { InView } from 'react-intersection-observer';

import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';

import styles from './Command.styles.m.css';

const Command = ({ index, command, bot, onSelect, isFocused, onHover, onChangeViewState }) => {
  const classes = classNames(popupItemStyles.smallContainer, {
    [popupItemStyles.active]: isFocused,
  });

  const onClick = () => {
    onSelect(command);
  };

  const onMouseEnter = () => {
    onHover(index);
  };

  const onChangeInView = (inView) => {
    onChangeViewState(index, inView);
  };

  return (
    <InView
      as="button"
      className={classes}
      onChange={onChangeInView}
      threshold={1}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      <div className={styles.container}>
        <PopupInfoCard
          className={styles.infoCard}
          type={AvatarTypes.Round_0}
          avatarTitle={command.command}
          avatarUrl={bot.avatarUrl}
          avatarBackgroundColorIndex={bot.id[bot.id.length - 1]}
          title={command.command}
          subtitle={command.description}
        />
      </div>
    </InView>
  );
};

export default memo(Command);
